export const RECURRING_OPTION_EVERY_DAY = 'every-day';
export const RECURRING_OPTION_EVERY_WEEK = 'every-week';
export const RECURRING_OPTION_EVERY_WEEKDAY = 'every-weekday';

export const RECURRING_OPTIONS = [
  RECURRING_OPTION_EVERY_DAY,
  RECURRING_OPTION_EVERY_WEEK,
  RECURRING_OPTION_EVERY_WEEKDAY,
];

export const END_OPTION_SPECIFIC_DATE = 'on-specific-day';
export const END_OPTION_AFTER_SESSIONS = 'after-sessions';

export const END_OPTIONS = [END_OPTION_SPECIFIC_DATE, END_OPTION_AFTER_SESSIONS];

export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri'];
export const ALL_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const IS_RECURRING_YES = 'yes';
export const IS_RECURRING_NO = 'no';

export const IS_RECURRING_OPTIONS = [IS_RECURRING_YES, IS_RECURRING_NO];
